import { useState, useEffect } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Logged-in client's saved Love / Avoid foods (null until loaded / when logged out)
export default function useFoodPreferences(user) {
  const [prefs, setPrefs] = useState(null);
  useEffect(() => {
    if (!user?.id) { setPrefs(null); return; }
    fetch(`${API}/food-preferences/mine?user_id=${encodeURIComponent(user.id)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setPrefs(d))
      .catch(() => setPrefs(null));
  }, [user?.id]);
  return prefs;
}
